import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * React Query key for a single per-org plugin row. Detail page reads.
 */
export function orgPluginQueryKey(organizationId: string, pluginName: string) {
  return ['org-plugin', organizationId, pluginName] as const;
}

export function useOrgPlugin(
  organizationId: string | null | undefined,
  pluginName: string | null | undefined,
) {
  return useQuery({
    queryKey: orgPluginQueryKey(organizationId ?? '', pluginName ?? ''),
    queryFn: () => api.getOrgPlugin(organizationId!, pluginName!),
    enabled: !!organizationId && !!pluginName,
  });
}
